import { render } from "./ProjectTasks.vue?vue&type=template&id=b125040a&scoped=true"
import script from "./ProjectTasks.vue?vue&type=script&lang=js"
export * from "./ProjectTasks.vue?vue&type=script&lang=js"

import "./ProjectTasks.vue?vue&type=style&index=0&id=b125040a&scoped=true&lang=css"
import "./ProjectTasks.vue?vue&type=style&index=1&id=b125040a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\GlavTV\\Documents\\GitHub\\octagon_uz\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b125040a"]])

export default __exports__